// extracted by mini-css-extract-plugin
export default {"placeholder":"dropdown_placeholder__rv1sn","menu":"dropdown_menu__7I3an","control":"dropdown_control__uE6WY","lg":"dropdown_lg__v7hqg","right":"dropdown_right__gjYLi"};